<div class="notification my-2">
  <span class="icon bi-info-circle me-2"></span
  ><span class="text my-a" [innerHTML]="label() | translate"></span>
</div>
